export default {
  forms: {
    title: 'フォーム',
    loading: '読み込み中...',
    noForms: '送信されたフォームはまだありません。',
    submittedOn: '送信日',
    backToList: 'フォーム一覧に戻る',
    notFound: 'フォームが見つかりません。',
    errors: {
      load: 'フォームの読み込みに失敗しました。もう一度お試しください。',
      loadOne: 'フォームの読み込みに失敗しました。もう一度お試しください。',
    },
  },
};
